"use client";
import { useEffect } from "react";

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);
  return (
    <html>
      <body>
        <main>
          <h1>Something went wrong</h1>
          <button onClick={() => reset()}>Try again</button>
        </main>
      </body>
    </html>
  );
}
